import DesignPreviewElementsSvg from "../svgs/DesignPreviewElementsSvg";
import Div from "../atoms/Div";

export default function DesignPreviewElements() {
	return (
		<Div position="absolute" top={'494px'} left={'0'} right={'0'} zIndex={'1'}>
			<DesignPreviewElementsSvg />
		</Div>
	)
}